var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgViewList = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11.488 6.4h16v5.312h-16zm0 18.624v-5.312h16v5.312zm0-6.624v-5.376h16V18.4zM4.8 11.712V6.4h5.376v5.312zm0 13.312v-5.312h5.376v5.312zm0-6.624v-5.376h5.376V18.4z"
})));
export { SvgViewList as ReactComponent };
export default __webpack_public_path__ + "static/media/view_list.ad701509.svg";